import React, { useEffect, useState } from 'react';
import close from '../../../../assets/Main/icon_close_modal.svg';
import star from '../../../../assets/Main/icon_star_yellow.svg';
import FileUpload from '../FileUpload';
import Stars from './Stars';
import '../../../../styles/Modal.css';

const COMPLAINT_REASONS = [
  'Мошенничество',
  'Грубое общение, оскорбления, агрессия',
  'Содержание профиля не соответствует действительности',
  'Цена сильно не соответствует названной',
  'Низкое качество услуги',
  'Объявление нарушает правила сервиса',
  'Другое',
];

const ChatModals = ({
  showCustomerAcceptModal,
  setShowCustomerAcceptModal,
  selectedChatExecutorCard,
  collaborationLoading,
  confirmCustomerAccept,
  showCustomerDeclineModal,
  setShowCustomerDeclineModal,
  confirmCustomerDecline,
  showDeclineConfirmModal,
  setShowDeclineConfirmModal,
  confirmDecline,
  showShareContactsAfterSelectModal,
  cancelShareContactsAfterSelect,
  confirmShareContactsAfterSelect,
  showShareContactsModal,
  setShowShareContactsModal,
  confirmShareContacts,
  modalShowReview,
  setModalShowReview,
  reviewText,
  setReviewText,
  userRole,
  reviewFiles,
  setReviewFiles,
  scoreQuality,
  setScoreQuality,
  scoreDeadlines,
  setScoreDeadlines,
  scoreBudget,
  setScoreBudget,
  scoreGoodFaith,
  setScoreGoodFaith,
  scoreCommunication,
  setScoreCommunication,
  scoreOverallImpression,
  setScoreOverallImpression,
  loadingReview,
  submitReview,
  showAcceptSuccessModal,
  setShowAcceptSuccessModal,
  showComplaintModal,
  setShowComplaintModal,
  complaintCategories,
  complaintLoading,
  complaintSubmitting,
  onSubmitComplaint,
  showCompleteOrderModal,
  setShowCompleteOrderModal,
  confirmCompleteOrder,
  showCompletionNotification,
  setShowCompletionNotification,
  showExecutorCompletionNotification,
  setShowExecutorCompletionNotification,
  currentOrderId,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);
  const [complaintReasons, setComplaintReasons] = useState([]);
  const [complaintText, setComplaintText] = useState('');
  const [complaintFiles, setComplaintFiles] = useState([]);
  const [reviewId, setReviewId] = useState(null);
  const [submittingReview, setSubmittingReview] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1023);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (showComplaintModal) {
      setComplaintReasons([]);
      setComplaintText('');
      setComplaintFiles([]);
    }
  }, [showComplaintModal]);

  useEffect(() => {
    if (modalShowReview) {
      setReviewId(null);
      setSubmittingReview(false);
    }
  }, [modalShowReview]);

  const toggleComplaintReason = (reason) => {
    setComplaintReasons((prev) =>
      prev.includes(reason) ? prev.filter((r) => r !== reason) : [...prev, reason]
    );
  };

  const resolveComplaintCategory = () => {
    if (!Array.isArray(complaintCategories) || complaintCategories.length === 0) {
      return 'COMPLAINT_CHAT';
    }

    const complaintChatCategory = complaintCategories.find(
      (item) => item.code === 'COMPLAINT_CHAT'
    );

    return complaintChatCategory?.code || 'COMPLAINT_CHAT';
  };

  const handleComplaintSubmit = () => {
    const reasonsText = complaintReasons.length
      ? `Причины жалобы: ${complaintReasons.join(', ')}`
      : '';

    const finalText = [reasonsText, complaintText.trim()].filter(Boolean).join('\n\n');

    if (!finalText.trim()) {
      alert('Опишите проблему');
      return;
    }

    onSubmitComplaint({
      categoryCode: resolveComplaintCategory(),
      text: finalText,
      files: complaintFiles,
    });
  };

  // const submitReview = async () => {
  //   if (!currentOrderId) {
  //     alert('Ошибка: ID заказа не найден');
  //     return;
  //   }

  //   if (!reviewText.trim()) {
  //     alert('Пожалуйста, напишите текст отзыва');
  //     return;
  //   }

  //   // валидация оценок (опущена для краткости)

  //   setSubmittingReview(true);

  //   try {
  //     let createdReviewId = reviewId;

  //     // 1. Создаём черновик отзыва
  //     if (!createdReviewId) {
  //       let createResponse;
  //       if (userRole === 'CUSTOMER') {
  //         createResponse = await apiClient.post(`/orders/customer-reviews/orders/${currentOrderId}`, {
  //           text: reviewText,
  //           scoreQuality,
  //           scoreDeadlines,
  //           scoreBudget,
  //           scoreCommunication,
  //           scoreOverallImpression,
  //         });
  //       } else {
  //         createResponse = await apiClient.post(`/orders/executor-reviews/orders/${currentOrderId}`, {
  //           text: reviewText,
  //           scoreCommunication,
  //           scoreGoodFaith,
  //           scoreOverallImpression,
  //         });
  //       }
  //       createdReviewId = createResponse.data.reviewId;
  //       setReviewId(createdReviewId);
  //     }

  //     // 2. Загружаем вложения (если есть)
  //     if (reviewFiles.length > 0 && createdReviewId) {
  //       for (let i = 0; i < reviewFiles.length; i++) {
  //         const file = reviewFiles[i];
  //         const formData = new FormData();
  //         formData.append('files', file);

  //         await apiClient.post(
  //           `/order-review-media/reviews/${createdReviewId}/attachments?sortOrder=${i}`,
  //           formData,
  //           { headers: { 'Content-Type': 'multipart/form-data' } }
  //         );
  //       }
  //     }

  //     // 3. Отправляем отзыв на модерацию
  //     const submitEndpoint = userRole === 'CUSTOMER'
  //       ? `/orders/customer-reviews/reviews/${createdReviewId}/submit`
  //       : `/orders/executor-reviews/reviews/${createdReviewId}/submit`;
  //     await apiClient.post(submitEndpoint);

  //     alert('Спасибо! Ваш отзыв отправлен на проверку');

  //     // 4. Сброс полей
  //     setReviewText('');
  //     if (userRole === 'CUSTOMER') {
  //       setScoreQuality(1);
  //       setScoreDeadlines(1);
  //       setScoreBudget(1);
  //       setScoreCommunication(1);
  //       setScoreOverallImpression(1);
  //     } else {
  //       setScoreGoodFaith(1);
  //       setScoreCommunication(1);
  //       setScoreOverallImpression(1);
  //     }
  //     setReviewFiles([]);
  //     setReviewId(null);
  //     setModalShowReview(false);

  //   } catch (error) {
  //     console.error('Ошибка при отправке отзыва:', error);
  //     alert(error.response?.data?.message || 'Произошла ошибка при отправке отзыва');
  //   } finally {
  //     setSubmittingReview(false);
  //   }
  // };


  return (
    <>
      {showCustomerAcceptModal && (
        <div className="modal-overlay" onClick={() => setShowCustomerAcceptModal(false)}>
          <div
            className="modal-window"
            onClick={(e) => e.stopPropagation()}
            style={isMobile?{}:{ padding: '35px', minWidth: '800px' }}
          >
            <button className="modal-close-btn" onClick={() => setShowCustomerAcceptModal(false)}>
              <img src={close} alt="" />
            </button>

            <h2
              style={{
                marginBottom: '25px',
                marginTop:isMobile?'10px':'30px',
                fontSize: isMobile ? '20px' : '32px',
                fontWeight: 600,
                textAlign: 'left',
                lineHeight: '1.1',
              }}
            >
              Подтвердите выбор исполнителя
            </h2>

            <div
              style={{
                border: '1px solid #DEDEDE',
                borderRadius: '10px',
                padding: '12px',
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px',
                textAlign: 'left',
              }}
            >
              <div
                style={{
                  width: '72px',
                  height: '72px',
                  borderRadius: '10px',
                  background: '#F3F3F3',
                  overflow: 'hidden',
                  flexShrink: 0,
                }}
              >
                {selectedChatExecutorCard?.avatar ? (
                  <img
                    src={selectedChatExecutorCard.avatar}
                    alt={selectedChatExecutorCard.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  <div className="avatar-placeholder" style={{ width: '100%', height: '100%' }} />
                )}
              </div>

              <div>
                <div
                  style={{
                    fontSize: isMobile ? '16px' : '24px',
                    fontWeight: 600,
                    marginBottom: '6px',
                    lineHeight: '1.1',
                  }}
                >
                  {selectedChatExecutorCard?.name || 'Имя пользователя'}
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    marginBottom: '6px',
                    fontSize: isMobile ? '14px' : '18px',
                  }}
                >
                  <span>{selectedChatExecutorCard?.rating || '—'}</span>
                  <img src={star} alt="★" style={{ width: '16px', height: '16px' }} />
                  <span>{selectedChatExecutorCard?.reviewsCount || 0} отзывов</span>
                </div>
              </div>
            </div>

            <p
              style={{
                color: '#656565',
                marginBottom: isMobile ? '20px' : '30px',
                textAlign: 'left',
                fontSize: isMobile ? '14px' : '20px',
              }}
            >
              Другие отклики будут автоматически отклонены
            </p>

            <div className="btns-group" style={{flexDirection: isMobile?'row':''}}>
              <button className="btn_blue" onClick={() => setShowCustomerAcceptModal(false)}>
                Отмена
              </button>

              <button
                className="btn_oran"
                onClick={confirmCustomerAccept}
                disabled={collaborationLoading}
              >
                {collaborationLoading ? 'Подтверждение...' : 'Подтвердить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showCustomerDeclineModal && (
        <div className="modal-overlay" onClick={() => setShowCustomerDeclineModal(false)}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowCustomerDeclineModal(false)}>
              <img src={close} alt="" />
            </button>

            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: isMobile ? '20px' : '24px',
              }}
            >
              Вы уверены,
              <br /> что хотите отклонить?
            </h3>

            <div className="btns-group" style={{flexDirection:isMobile?'row':''}}>
              <button onClick={() => setShowCustomerDeclineModal(false)} className="btn_blue">
                Нет
              </button>
              <button
                onClick={confirmCustomerDecline}
                className="btn_oran"
                disabled={collaborationLoading}
              >
                {collaborationLoading ? '...' : 'Да'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeclineConfirmModal && (
        <div className="modal-overlay" onClick={() => setShowDeclineConfirmModal(false)}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: isMobile ? '20px' : '24px',
              }}
            >
              Вы уверены, что хотите отклонить?
            </h3>

            <button
              className="modal-close-btn"
              onClick={() => setShowDeclineConfirmModal(false)}
            >
              <img src={close} alt="" />
            </button>

            <div className="btns-group">
              <button onClick={() => setShowDeclineConfirmModal(false)} className="btn_blue">
                Отмена
              </button>
              <button onClick={confirmDecline} className="btn_oran">
                Да, отклонить
              </button>
            </div>
          </div>
        </div>
      )}

      {showShareContactsAfterSelectModal && (
        <div className="modal-overlay" onClick={cancelShareContactsAfterSelect}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={cancelShareContactsAfterSelect}>
              <img src={close} alt="" />
            </button>

            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: isMobile ? '20px' : '24px',
              }}
            >
              Желаете поделиться своими контактами с исполнителем?
            </h3>

            <div className="btns-group" style={isMobile?{flexDirection:'row'}:{}}>
              <button onClick={cancelShareContactsAfterSelect} className="btn_blue">
                Нет
              </button>

              <button onClick={confirmShareContactsAfterSelect} className="btn_oran">
                Да
              </button>
            </div>
          </div>
        </div>
      )}

      {showShareContactsModal && (
        <div className="modal-overlay" onClick={() => setShowShareContactsModal(false)}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: isMobile ? '20px' : '24px',
              }}
            >
              Поделиться контактами?
            </h3>

            <button className="modal-close-btn" onClick={() => setShowShareContactsModal(false)}>
              <img src={close} alt="" />
            </button>

            <p
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: isMobile ? '14px' : '18px',
              }}
            >
              Ваши контакты будут отправлены собеседнику
            </p>

            <div className="btns-group">
              <button onClick={() => setShowShareContactsModal(false)} className="btn_blue">
                Отмена
              </button>

              <button onClick={confirmShareContacts} className="btn_oran">
                Да, поделиться
              </button>
            </div>
          </div>
        </div>
      )}

      {showComplaintModal && (
        <div className="modal-overlay" onClick={() => setShowComplaintModal(false)}>
          <div
            className="modal-window"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: isMobile ? '95%' : '800px',
              maxWidth: '800px',
              padding: isMobile ? '20px' : '35px',
              borderRadius: '10px',
            }}
          >
            <button className="modal-close-btn" onClick={() => setShowComplaintModal(false)}>
              <img src={close} alt="" />
            </button>

            <h2
              style={{
                fontSize: isMobile ? '20px' : '33px',
                color: '#000',
                fontWeight: 600,
                lineHeight: 1.1,
                marginBottom: '35px',
                textAlign: 'left',
              }}
            >
              Причины жалобы
            </h2>

            {complaintLoading ? (
              <div style={{ marginBottom: '20px', textAlign: 'left' }}>Загрузка категорий...</div>
            ) : (
              <div className="checkbox-grid">
                {COMPLAINT_REASONS.map((reason) => (
                  <div
                    key={reason}
                    className="checkbox-wrapper"
                    onClick={() => toggleComplaintReason(reason)}
                    style={{ marginBottom: '0px' }}
                  >
                    <div
                      className={`custom-checkbox ${
                        complaintReasons.includes(reason) ? 'checked' : ''
                      }`}
                    >
                      {complaintReasons.includes(reason) && (
                        <svg
                          width="14"
                          height="10"
                          viewBox="0 0 14 10"
                          fill="none"
                          className="check-icon"
                        >
                          <path
                            d="M1 5L5 9L13 1"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>

                    <span
                      className="checkbox-text"
                      style={{
                        color: '#000',
                        fontWeight: '500',
                        fontSize: isMobile ? '18px' : '24px',
                        textAlign: 'left',
                        lineHeight: '1.2'
                      }}
                    >
                      {reason}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <div
              style={{
                textAlign: 'left',
                fontSize: isMobile ? '16px' : '20px',
                color: '#151515',
                fontWeight: 500,
                marginTop: '20px',
                marginBottom: '0px',
              }}
            >
              Опишите проблему подробнее
            </div>

            <div
              style={{
                textAlign: 'left',
                color: '#656565',
                fontSize: isMobile ? '14px' : '16px',
                marginBottom: '7px',
              }}
            >
              Прикрепите файлы с подтверждением (при наличии), чтобы мы разобрались быстрее
            </div>

            <div style={{ marginBottom: '15px' }}>
              <FileUpload onFilesUpload={setComplaintFiles} maxFiles={3} />
            </div>

            <textarea
              value={complaintText}
              onChange={(e) => setComplaintText(e.target.value)}
              placeholder="Расскажите, что произошло, чтобы мы могли разобраться"
              maxLength={2000}
              style={{
                width: '100%',
                minHeight: '135px',
                resize: 'none',
                border: '1px solid #ECA288',
                background: '#FAFAFA',
                borderRadius: '7px',
                padding: '20px',
                fontSize: '16px',
                outline: 'none',
                boxSizing: 'border-box',
                marginBottom: '20px',
              }}
            />

            <div className="btns-group" style={{ gap: '12px' }}>
              <button className="btn_blue" onClick={() => setShowComplaintModal(false)}>
                Отмена
              </button>

              <button
                className="btn_oran"
                onClick={handleComplaintSubmit}
                disabled={complaintSubmitting}
              >
                {complaintSubmitting ? 'Отправка...' : 'Отправить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalShowReview && (
        <div className="modal-overlay" style={{ overflowY: 'auto', margin: 0 }}>
          <div className="modal-window-review review-modal-adaptive" style={{ margin: userRole === 'EXECUTOR' ? '0' : '650px 0 50px 0' }}>
            <button className="modal-close-btn" onClick={() => setModalShowReview(false)}>
              <img src={close} alt="" />
            </button>

            <h2 className="review-modal-title">Оставьте отзыв</h2>

            <div className="review-modal-label">Напишите подробный отзыв (до 1000 символов)</div>

            <textarea
              placeholder="Текст отзыва"
              value={reviewText}
              maxLength={1000}
              onChange={(e) => setReviewText(e.target.value)}
              className="review-textarea"
            />

            <div className="review-counter">{reviewText.length} из 1000 символов</div>

            {userRole === 'CUSTOMER' && (
              <>
                <div className="review-modal-label">Фото</div>
                <p className="review-modal-note">
                  Загрузите фотографии, чтобы дополнить отзыв (до 10 мб)
                </p>
                <FileUpload onFilesUpload={setReviewFiles} maxFiles={3} />
              </>
            )}

            <div style={{ marginTop: '30px', textAlign: 'left' }}>
              {userRole === 'CUSTOMER' && (
                <>
                  <div className="review-factor-zag">Качество работы</div>
                  <Stars value={scoreQuality} setValue={setScoreQuality} />
                  <div className="review-factor-zag">Соблюдение сроков</div>
                  <Stars value={scoreDeadlines} setValue={setScoreDeadlines} />
                  <div className="review-factor-zag">Соблюдение бюджета</div>
                  <Stars value={scoreBudget} setValue={setScoreBudget} />
                  <div className="review-factor-zag">Коммуникация</div>
                  <Stars value={scoreCommunication} setValue={setScoreCommunication} />
                  <div className="review-factor-zag">Общее впечатление</div>
                  <Stars
                    value={scoreOverallImpression}
                    setValue={setScoreOverallImpression}
                  />
                </>
              )}

              {userRole === 'EXECUTOR' && (
                <>
                  <div className="review-factor-zag">Добросовестность</div>
                  <Stars value={scoreGoodFaith} setValue={setScoreGoodFaith} />
                  <div className="review-factor-zag">Коммуникация</div>
                  <Stars value={scoreCommunication} setValue={setScoreCommunication} />
                  <div className="review-factor-zag">Общее впечатление</div>
                  <Stars
                    value={scoreOverallImpression}
                    setValue={setScoreOverallImpression}
                  />
                </>
              )}
            </div>

            <div className="btns-group" style={{ marginTop: '30px' }}>
              <button className="btn_blue" onClick={() => setModalShowReview(false)}>
                Отмена
              </button>
              <button 
                className="btn_oran" 
                onClick={submitReview} 
                disabled={loadingReview || submittingReview}
              >
                {loadingReview || submittingReview ? 'Отправка...' : 'Отправить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showAcceptSuccessModal && (
        <div className="modal-overlay" onClick={() => setShowAcceptSuccessModal(false)}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: isMobile ? '20px' : '24px',
              }}
            >
              Приглашение принято
            </h3>

            <div className="btns-group" style={{ justifyContent: 'center' }}>
              <button className="btn_oran" onClick={() => setShowAcceptSuccessModal(false)}>
                ОК
              </button>
            </div>
          </div>
        </div>
      )}

      {showCompletionNotification && (
        <div className="modal-overlay" onClick={() => setShowCompletionNotification(false)}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowCompletionNotification(false)}>
              <img src={close} alt="" />
            </button>

            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>
              Заказчик сообщил, что заказ завершен
            </h3>

            <p style={{ textAlign: 'center', marginBottom: '20px' }}>
              Оставьте отзыв о работе заказчика - это поможет другим пользователям!
            </p>

            <div className="btns-group">
              <button 
                className="btn_oran" 
                onClick={() => {
                  setShowCompletionNotification(false);
                  setModalShowReview(true);
                }}
              >
                Оставить отзыв
              </button>
              <button 
                className="btn_blue" 
                onClick={() => setShowCompletionNotification(false)}
              >
                Позже
              </button>
            </div>
          </div>
        </div>
      )}

      {showCompleteOrderModal && (
        <div className="modal-overlay" onClick={() => setShowCompleteOrderModal(false)}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowCompleteOrderModal(false)}>
              <img src={close} alt="" />
            </button>

            <h3 style={{ textAlign: 'center', marginBottom: '20px', color:'#000', fontWeight:'500', marginTop:'-20px' }}>
              Подтвердите завершение заказа
            </h3>

            <p style={{ textAlign: 'center', marginBottom: '20px', color: '#656565' }}>
              После завершения заказа вы сможете оставить отзыв
            </p>

            <div className="btns-group">
              <button 
                className="btn_blue" 
                onClick={() => setShowCompleteOrderModal(false)}
              >
                Отмена
              </button>
              <button 
                className="btn_oran" 
                onClick={confirmCompleteOrder}
                disabled={collaborationLoading}
              >
                {collaborationLoading ? 'Завершение...' : 'Завершить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showExecutorCompletionNotification && userRole === 'EXECUTOR' && (
        <div className="modal-overlay" onClick={() => setShowExecutorCompletionNotification(false)}>
          <div className="modal-window modal-small" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowExecutorCompletionNotification(false)}>
              <img src={close} alt="" />
            </button>

            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>
              Заказчик сообщил, что заказ завершен
            </h3>

            <p style={{ textAlign: 'center', marginBottom: '20px' }}>
              Оставьте отзыв о работе заказчика - это поможет другим пользователям!
            </p>

            <div className="btns-group">
              <button 
                className="btn_oran" 
                onClick={() => {
                  setShowExecutorCompletionNotification(false);
                  setModalShowReview(true);
                }}
              >
                Оставить отзыв
              </button>
              <button 
                className="btn_blue" 
                onClick={() => setShowExecutorCompletionNotification(false)}
              >
                Позже
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatModals;
